// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__2uFYn","content":"LoadingAlert_content__k6e8C"};